/** Grymwyrd 简体中文文本 - 游戏/VTT功能相关内容。 */
export const playZhCN = {
  // CampaignList
  'play.campaigns.heading': '我的战役',
  'play.campaigns.signIn': '登录',
  'play.campaigns.signInToSee': '以查看您参加的战役。',
  'play.campaigns.fallbackNotice': '显示示例战役 — 无法加载您的名单。',
  'play.campaigns.loading': '回忆您的传奇故事…',
  'play.campaigns.empty': '您还未加入任何战役。',
  'play.campaigns.assignedCharacter': '已分配的角色',
  'play.campaigns.unassigned': '未分配',
  'play.campaigns.noCharactersYet': '还未有角色',
  'play.campaigns.enterCampaign': '进入战役',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': '牌桌',
  'play.vtt.launch': '启动VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — 战役 {campaignId}',
  'play.vtt.veilHeadline': '现实与传奇间的帷幕于此处尤其薄弱。',
  'play.vtt.prototypeIntro':
    '实时虚拟牌桌是后续阶段。互动原型将嵌入此框架 — 按',
  'play.vtt.prototypeOutro': '准备容器。',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': '法典快速搜索',
  'play.codex.searchPlaceholder': '查找怪物、法术、规则…',
  'play.codex.searchAriaLabel': '搜索百科全书',
  'play.codex.searching': '窥视…',
  'play.codex.noResults': '未找到"{q}"的结果。',
  'play.codex.hint': '输入至少两个字符以在牌桌前搜索活百科，无需离开。',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': '战役',
  'play.campaign.fallbackDescription':
    '无法加载战役详情 — 您仍可在下方准备角色。',
  'play.campaign.seoTitle': '战役',
  'play.campaign.noneSpecified': '未指定战役。',
  'play.campaign.seoTitleNamed': '{title} — 游戏',
  'play.campaign.seoTitleDefault': '战役 — 游戏',
  'play.campaign.backToLobby': '返回大厅',
  'play.campaign.gm': '主持人 {gm}',
  'play.campaign.playersCount': '{count} 名玩家',

  // CharacterSheet
  'play.sheet.savedToCodex': '已保存至您的法典。',
  'play.sheet.savedLocally': '已在本地保存（服务器不可用）。',
  'play.sheet.saveError': '无法保存您的角色 — 存储不可用。',
  'play.sheet.loading': '展开角色卡…',
  'play.sheet.heading': '角色卡',
  'play.sheet.avatarAlt': '{name}的头像',
  'play.sheet.unclaimedHero': '未认领的英雄',
  'play.sheet.abilityCheck': '{ability}检定（{formula}）：',
  'play.sheet.name': '名字',
  'play.sheet.namePlaceholder': '无名游客',
  'play.sheet.level': '等级',
  'play.sheet.speciesLabel': '血统/种族',
  'play.sheet.loadingOption': '加载中…',
  'play.sheet.selectSpecies': '选择种族',
  'play.sheet.classLabel': '职业',
  'play.sheet.selectClass': '选择职业',
  'play.sheet.abilityScores': '属性值',
  'play.sheet.abilityScoresHint': '（单击修正值以掷骰）',
  'play.sheet.abilityScoreAria': '{ability}属性值',
  'play.sheet.rollCheckAria': '掷{ability}检定',
  'play.sheet.hp': '生命值',
  'play.sheet.maxHp': '最大生命值',
  'play.sheet.ac': '防御等级',
  'play.sheet.backstory': '背景故事',
  'play.sheet.backstoryPlaceholder': '何种黑暗之力将这灵魂引向此桌？',
  'play.sheet.canonCandidate': '正典候选',
  'play.sheet.canonCandidateHint': '同意此角色被纳入Grymwyrd活态正典的考量。',
  'play.sheet.saving': '保存中…',
  'play.sheet.saveCharacter': '保存角色',

  // CreateGameModal
  'play.create.errorNoName': '为您的牌桌起一个名字。',
  'play.create.errorNoSystem': '选择游戏系统。',
  'play.create.you': '您',
  'play.create.errorCreate': '仪式失败 — 无法创建您的牌桌。请稍后重试。',
  'play.create.modalTitle': '聚集一个牌桌',
  'play.create.successCopy': '牌桌已就绪。分享此邀请链接以召唤您的玩家。',
  'play.create.copyInviteAria': '复制邀请链接',
  'play.create.copied': '已复制',
  'play.create.copy': '复制',
  'play.create.done': '完成',
  'play.create.tableName': '牌桌名称',
  'play.create.tableNamePlaceholder': '例 哀悼之穹顶',
  'play.create.quickStart': '快速开始',
  'play.create.quickStartAria': '快速开始预设',
  'play.create.customPreset': '自定义',
  'play.create.customPresetDesc': '从零开始',
  'play.create.gameSystem': '游戏系统',
  'play.create.loadingSystems': '加载系统中…',
  'play.create.systemFromPreset': '{system}（来自预设）',
  'play.create.systemDefault': 'Grymwyrd 大灾变（默认）',
  'play.create.tags': '标签',
  'play.create.tagsUpTo': '（最多 {count} 个）',
  'play.create.removeTagAria': '移除标签 {tag}',
  'play.create.tagLimitReached': '已达标签上限',
  'play.create.tagPlaceholder': '恐怖、单人战役…',
  'play.create.maxPlayers': '最大玩家数：',
  'play.create.cancel': '取消',
  'play.create.convening': '正在聚集…',
  'play.create.createTable': '创建牌桌',

  // JoinPage
  'play.join.finding': '查找牌桌中…',
  'play.join.expiredHeading': '此邀请已过期',
  'play.join.expiredBody': '代码出于安全考虑会过期。请向主持人索要新的。',
  'play.join.browseLiveTables': '浏览活跃牌桌',
  'play.join.errorHeading': '无法连接到牌桌',
  'play.join.errorBody': '查找邀请时出错。请检查您的连接并重试。',
  'play.join.tryAgain': '重试',
  'play.join.defaultTableTitle': '一个Grymwyrd牌桌',
  'play.join.invited': '您被邀请入席。',
  'play.join.signInToSeat': '登录以入席',
  'play.join.createAccount': '初次到访？创建免费账户',
  'play.join.opensAfterSignIn': '登录后牌桌将开启。',

  // PlayLobbyPage
  'play.lobby.seoTitle': '游戏 — 虚拟牌桌',
  'play.lobby.seoDescription':
    '寻找牌桌、加入实时对局，在Grymwyrd虚拟牌桌铸就您的传奇。',
  'play.lobby.eyebrow': '虚拟牌桌',
  'play.lobby.title': '游戏',
  'play.lobby.subtitle':
    '聚集您的秘党。掷动骨牌。在一个每个选择都在Grymwyrd活态正典中回响的牌桌前入席。',
  'play.lobby.createGame': '创建游戏',
  'play.lobby.playNow': '现在游戏 — 无需账户',
  'play.lobby.signInToHost': '登录以主持您自己的牌桌',

  // SessionListLive
  'play.live.heading': '现在直播',
  'play.live.empty': '此刻无活跃牌桌。帷幕沉寂 — 开启您自己的。',
  'play.live.badge': '直播',
  'play.live.unknownSystem': '未知系统',
  'play.live.gmSuffix': ' · 主持人 {gm}',
  'play.live.players': '位玩家',

  // TableList — empty board
  'play.tables.emptyHeading': '尚无开放的牌桌',
  'play.tables.emptyBody':
    '牌桌现已寂静。为第一个拉起椅子的人 — 试试访客牌桌，无需账户。',
  'play.tables.tryGuestTable': '试试访客牌桌',
  'play.tables.orUse': '或使用',
  'play.tables.createGame': '创建游戏',
  'play.tables.aboveToHost': '上方来主持您自己的。',

  // TableList — waitlist
  'play.waitlist.joinError': '无法加入等待列表 — 请重试。',
  'play.waitlist.leaveError': '无法离开等待列表 — 请重试。',
  'play.waitlist.join': '加入等待列表',
  'play.waitlist.leaving': '离开中…',
  'play.waitlist.leave': '离开等待列表',
  'play.waitlist.joining': '加入中…',

  // TableList — board
  'play.tables.heading': '开放的牌桌',
  'play.tables.openSeatOnly': '仅开放席位',
  'play.tables.systemFilterPlaceholder': '系统…',
  'play.tables.systemFilterAria': '按系统过滤',
  'play.tables.tagsFilterPlaceholder': '标签（逗号分隔）…',
  'play.tables.tagsFilterAria': '按标签过滤',
  'play.tables.fetchError': '无法连接到活动讯板 — 大厅暂时不可用。',
  'play.tables.loading': '集聚牌桌中…',
  'play.tables.untitledTable': '无标题牌桌',
  'play.tables.full': '满座',
  'play.tables.seatedCount': '{count} 位已入席',
  'play.tables.viewTable': '查看牌桌',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': '牌桌聊天',
  'chat.empty': '暂无消息。向牌桌说点什么。',
  'chat.inputPlaceholder': '向牌桌发消息…',
  'chat.inputAria': '聊天消息',
  'chat.send': '发送',
  'chat.translatedFrom': '翻译自 {lang}',
  'chat.original': '原文',
  'chat.showOriginal': '显示原文',
  'chat.showTranslation': '显示翻译',
  'chat.showOriginalsAll': '显示所有原文',
  'chat.showTranslationsAll': '显示所有翻译',
}
